import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./pages/styles/common.css";
import "./pages/styles/DragandDrop.css";
import "./pages/styles/FormNew.css";
import "././css/style.css";
import "././css/custom.scss";

import * as AuthService from "./services/authService";

import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai';
import { Link, Route, Routes, useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";

import FullLayout from "./layouts/FullLayout";
import IUser from './types/user.type';
import { IconContext } from 'react-icons';
import Login from "./pages/Login";
import React from "react";
import Register from "./pages/Register";
import { RoleContext, RoleUpdateContext, AuthorizationContext, AlertContext } from "./utils/contexts/RoleContext";
import styled from 'styled-components';
import Users from "./pages/Users";
import Request from "./pages/Request";
import Toast from 'react-bootstrap/Toast';
import CrudDetails from "./pages/CrudDetails";
import Settings from "./pages/settings";
import MyAccount from "./pages/myAccount";
import ResetPassword from "./pages/ResetPassword";
import Transaction from "./pages/Transaction";
import KYCRequests from "./pages/KYCRequests";
import Privacy from "./pages/Privacy";
import TermsAndConditions from "./pages/TermsAndConditions";



const NavIcon = styled(Link)`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 5rem;
    font-size: 2rem;
    margin-left: 2rem;
`;

const App = () => {
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState<IUser | undefined>(undefined);
  const [sidebar, setSidebar] = useState(false);
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState("");
  const [successValue, setSuccessValue] = useState("");

  const showSidebar = () => setSidebar(!sidebar);

  const Authorization = useContext(AuthorizationContext)


  useEffect(() => {
    // requestPermission();
  }, []);

  const logOut = () => {
    AuthService.logout();
  };

  function requestPermission() {
    console.log("Requesting permission...");
    Notification.requestPermission().then((permission) => {
      console.log("permission", permission);
      if (permission === "granted") {
        console.log("Notification permission granted.");
      }
    });
  }

  const settingToast = async (message: string, theme: string) => {
    setShow(true);
    setMessage(message);
    setSuccessValue(theme);
    setTimeout(() => setShow(false), 2000)
  }


  return (
    <RoleContext.Provider value={currentUser}>
      <RoleUpdateContext.Provider value={(role: any) => setCurrentUser(role)}>
        <AlertContext.Provider value={{
          show: show,
          successValue: successValue,
          message: message,
          setToast: settingToast
        }}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/users" element={<Users />} />
            <Route path="/requests" element={<Request />} />
            <Route path="/crud-details" element={<CrudDetails />} />
          <Route path="/crud-details/:id" element={<CrudDetails />} />
          <Route path="/settings" element={<Settings />} />
            <Route path="/my-account" element={<MyAccount />} />
            <Route path="/change-password" element={<ResetPassword />} />
            <Route path="/transaction-history" element={<Transaction />} />
            <Route path="/transaction-history/:id" element={<Transaction />} />
            <Route path="/kyc-requests" element={<KYCRequests />} />

            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
           

          </Routes>
        </AlertContext.Provider>
      </RoleUpdateContext.Provider>
    </RoleContext.Provider>
  );
};

export default App;